import { rootApi } from '../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['AssignVolume'],
});

export const assignVolumeApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findEntryAssignVolume: builder.mutation({
      query: () => `assign_volume/assign_entry/`,
      keepUnusedDataFor: 0,
      providesTags: ['AssignVolume'],
    }),
    setDiagramPeriodAssignVolume: builder.mutation({
      query: (payload) => ({
        url: `plan_job/`,
        method: 'POST',
        body: payload,
      }),

      keepUnusedDataFor: 0,
      providesTags: ['AssignVolume'],
    }),
    searchDataYardAssignVolume: builder.mutation({
      query: (payload) =>
        `assign_volume/display_summary_volume/?period_from=${payload.period_from}&period_to=${payload.period_to}&location_from=${payload.location_from}`,
      keepUnusedDataFor: 0,
      providesTags: ['AssignVolume'],
    }),
    getProgressStatus: builder.mutation({
      query: (payload) =>
        `assign_volume/status/?plan_job_id=${payload.plan_job_id}`,
      keepUnusedDataFor: 0,
      providesTags: ['AssignVolume'],
    }),
    uploadFileAssignVolume: builder.mutation({
      query: (payload) => ({
        url: `assign_volume/create_or_update_file/`,
        method: 'POST',
        body: payload,
      }),

      keepUnusedDataFor: 0,
      providesTags: ['AssignVolume'],
    }),
    findFilterDataAssignVolume: builder.mutation({
      query: (payload) =>
        `assign_volume/filter_data/?period_from=${payload.period_from}&period_to=${payload.period_to}&location_from=${payload.location_from}`,
      keepUnusedDataFor: 0,
      providesTags: ['AssignVolume'],
    }),
    // findFilterSearchVolume: builder.mutation({
    //   query: (payload) =>
    //     `assign_volume/display_detail_volume/?volume_date=${payload.volume_date}&vehicle_type=${payload.vehicle_type}&location_from=${payload.location_from}&location_to=${payload.location_to}&region=${payload.region}&limit=${payload.limit}&offset=${payload.offset}`,
    //   keepUnusedDataFor: 0,
    //   providesTags: ["AssignVolume"],
    // }),
    findFilterSearchVolume: builder.mutation({
      query: (payload) => {
        let url = `assign_volume/display_detail_volume/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v === 'All' ? 'all' : v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);

        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      providesTags: ['AssignVolume'],
    }),
    editVolumeAssignVolume: builder.mutation({
      query: (payload) => ({
        url: `assign_volume/edit_volume/`,
        method: 'PATCH',
        body: payload,
      }),

      keepUnusedDataFor: 0,
      providesTags: ['AssignVolume'],
    }),
    clearDataVolumeAssignVolume: builder.mutation({
      query: (payload) => ({
        url: `assign_volume/clear_data/`,
        method: 'DELETE',
        body: payload,
      }),

      keepUnusedDataFor: 0,
      providesTags: ['AssignVolume'],
    }),
    confirmDataVolumeAssignVolume: builder.mutation({
      query: (payload) => ({
        url: `assign_volume/confirm_data/`,
        method: 'POST',
        body: payload,
      }),

      keepUnusedDataFor: 0,
      providesTags: ['AssignVolume'],
    }),
    createDefaultTrailerCalendar: builder.mutation({
      query: (payload) => `trailer_calendars/default/?year=${payload.year}&month=${payload.month}`,
      keepUnusedDataFor: 0,
      providesTags: ['AssignVolume'],
    }),
    confirmAssignVolumeVerify: builder.mutation({
      query: (payload) => ({
        url: `assign_volume/verify/`,
        method: 'POST',
        body: payload,
      }),

      keepUnusedDataFor: 0,
      providesTags: ['AssignVolume'],
    }),

    
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindEntryAssignVolumeMutation,
  useGetProgressStatusMutation,
  useSetDiagramPeriodAssignVolumeMutation,
  useSearchDataYardAssignVolumeMutation,
  useUploadFileAssignVolumeMutation,
  useFindFilterDataAssignVolumeMutation,
  useFindFilterSearchVolumeMutation,
  useEditVolumeAssignVolumeMutation,
  useClearDataVolumeAssignVolumeMutation,
  useConfirmDataVolumeAssignVolumeMutation,
  useCreateDefaultTrailerCalendarMutation,
  useConfirmAssignVolumeVerifyMutation,
} = assignVolumeApi;
